import React from 'react';
import './Home.css'
import {Link} from 'react-router-dom';

const Home = () => {
    return (
        <div className='wrapper'>
        <div className="home-container">
            <h1 className='home-title'>
                <span className='greeting'>Hi! </span>
                <span className='intro'>I'm Pranit.</span>
            </h1>
            <div className="info-box">
                <p>I love developing impactful software solutions from the ground up. With a knack for turning data into discoveries and an eye for automation, I'm ready to tackle the future of tech!</p>
            </div>
            <div className="read-more"><Link to="/about">Read More</Link></div>
        </div>
        </div>
    )
}

export default Home;